module.exports = __webpack_public_path__ + "img/06-6.376c8119.png";